import {handleResponse} from "@/services/service-helpers.ts"
import {MemberAddressListItem} from "@/models/member-address-list.ts"
import log from '@/lib/logger'

const BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/reports/address-list`

export async function getAddressList(
    token: string | null
): Promise<MemberAddressListItem[]> {
    if (!token) {
        log.error("No token provided to request address list")
        return Promise.reject("No token provided")
    }

    const response = await fetch(BASE_URL, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        })
    })

    const result = await handleResponse<MemberAddressListItem[]>(response)
    return result || []
}

export async function exportAddressListExcel(token: string | null): Promise<{blob: Blob, filename: string}> {
    if (!token) {
        log.error("No token provided to export address list")
        return Promise.reject("No token provided")
    }

    const response = await fetch(`${BASE_URL}/export/excel`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })

    if (!response.ok) {
        throw new Error('Excel download failed')
    }

    const blob = await response.blob()

    const contentDisposition = response.headers.get('Content-Disposition')
    let filename = 'Mitgliederanschriften.xlsx'

    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/)
        if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1]
        }
    }

    return {blob, filename}
}
